import LazyLoad from "vanilla-lazyload";

export default {
    init: () => {
        const lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy"
        });
    }
}
